module.exports = __webpack_public_path__ + "static/media/download_src_3.5dda7816.jpg";